var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigurerun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 19.9761 25.8633",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 25.8633,
    opacity: 0,
    width: 19.9761,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2498 5.10938C13.6677 5.10938 14.8045 3.97266 14.8045 2.55469C14.8045 1.13672 13.6677 0 12.2498 0C10.8318 0 9.69508 1.13672 9.69508 2.55469C9.69508 3.97266 10.8318 5.10938 12.2498 5.10938ZM8.24196 15.3047L12.7302 17.8242L9.83571 20.3086C9.21461 20.8359 9.22633 21.5273 9.60133 21.9492C9.98805 22.3828 10.6795 22.4883 11.324 21.9375L15.367 18.4922C15.9177 18.0234 15.8357 17.0156 15.1677 16.582L10.7732 13.6992L11.6404 10.6641C11.7576 10.2305 12.2615 10.1719 12.5193 10.5469L13.8084 12.4336C14.113 12.8672 14.6638 13.043 15.1677 12.8086L18.8826 11.1562C19.5388 10.8633 19.7849 10.2891 19.5037 9.69141C19.2107 9.10547 18.6482 8.92969 17.992 9.22266L15.0505 10.5234L13.0232 7.72266C11.9685 6.26953 10.656 5.67188 8.49977 5.83594L4.38649 6.12891C3.73024 6.17578 3.28492 6.59766 3.19117 7.27734L2.64039 11.4492C2.53492 12.1758 2.89821 12.6797 3.54274 12.75C4.19899 12.8086 4.62086 12.4336 4.71461 11.707L5.21852 8.29688L6.87086 8.17969C7.23414 8.14453 7.59742 8.40234 7.46852 8.85938L6.50758 12.2109C5.94508 14.1914 7.23414 14.7305 8.24196 15.3047ZM0.402112 25.4297C0.835705 25.793 1.50367 25.8398 2.10133 25.2656L5.89821 21.5039C6.21461 21.1875 6.28492 21.1172 6.48414 20.625L8.07789 16.5L7.69117 16.2891C6.80055 15.8086 6.17946 15.3164 5.75758 14.7891L4.36305 19.7227L0.425549 23.6484C-0.195545 24.2578-0.0783571 25.0078 0.402112 25.4297Z",
    fill: "currentColor",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigurerun);
export default __webpack_public_path__ + "static/media/figure.run.f180c409b771c2b2776265f964af026b.svg";
export { ForwardRef as ReactComponent };